import React from "react";
import styles from "./ProviderList.module.css";

// Provider list component
function ProviderList({ providers, onEdit, onDelete }) {
  if (providers.length === 0) return null;

  return (
    <div className={styles.providerList}>
      <h4 className={styles.providerListTitle}>Added Providers</h4>
      <table className={styles.providersTable}>
        <thead>
          <tr>
            <th>Provider FTIN</th>
            <th>Provider Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {providers.map((provider, index) => (
            <tr key={index}>
              <td>{provider.ftin}</td>
              <td>{provider.providerName}</td>
              <td style={{ width: "120px" }}>
                <button
                  type="button"
                  className={`btn btn-sm ${styles.actionButton}`}
                  onClick={() => onEdit(index)}
                >
                  Edit
                </button>
                <button
                  type="button"
                  className={`btn btn-sm ${styles.actionButton}`}
                  onClick={() => onDelete(index)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export { ProviderList };
